import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CardTitle,
    Input,
} from '@repo/shadcn';
import { useState } from 'react';
import { toast } from 'sonner';

import { useUpdateCustomerPaymentMutation } from '@/features/slice/wholesale-admin';
import { logError } from '@/utils';
import { formatCurrencyInBDT } from '@/utils/currency-formater';

import { useWholesaleCustomerDetails } from './hook';

export const ActionButtons = () => {
    const { data } = useWholesaleCustomerDetails();
    const [paymentAmount, setPaymentAmount] = useState('');
    const [updatePayment, { isLoading }] = useUpdateCustomerPaymentMutation();

    const totalDue = data?.data?.order_summary.total_due || 0;

    const handlePaymentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (+value > data?.data?.order_summary.total_due) {
            setPaymentAmount(
                data?.data?.order_summary.total_due.toString() || '',
            );
        } else if (+value < 0) {
            setPaymentAmount('0');
        } else {
            setPaymentAmount(value);
        }
    };

    const handlePaymentSubmit = async () => {
        if (!paymentAmount || +paymentAmount <= 0) return;
        try {
            await updatePayment({
                customerId: data?.data?.id || '',
                body: { amount: +paymentAmount },
            }).unwrap();

            toast.success('Payment updated successfully');
            setPaymentAmount('');
        } catch (error) {
            logError('ActionButtons - handlePaymentSubmit: ', error);
            toast.error('Failed to update payment. Please try again.');
        }
    };

    return (
        <Card>
            <CardHeader>
                <CardTitle>Actions</CardTitle>
            </CardHeader>
            <CardContent>
                <div>
                    <div className="mb-4 space-y-2">
                        <span className="block">
                            Payment Amount (
                            {formatCurrencyInBDT(
                                data?.data?.order_summary.total_due,
                            )}
                            )
                        </span>
                        <Input
                            placeholder="Enter amount"
                            type="number"
                            className="text-right"
                            value={paymentAmount}
                            onChange={handlePaymentChange}
                        />
                        <div className="flex justify-end">
                            <Button
                                onClick={handlePaymentSubmit}
                                disabled={
                                    isLoading ||
                                    !paymentAmount ||
                                    +paymentAmount <= 0 ||
                                    totalDue <= 0
                                }
                            >
                                {isLoading ? 'Updating...' : 'Update Payment'}
                            </Button>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
